export const INVITATION_BY_TOKEN = "INVITATION_BY_TOKEN";
